export const initialState = {
    id: '',
    location: '',
};

export const regionsAndLocationsPath = '/regions-and-locations';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'Regions and Locations', path: regionsAndLocationsPath },
    { label: 'Add Location', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'Regions and Locations', path: regionsAndLocationsPath },
    { label: 'Edit Location', path: '' },
];

export const addHeader = 'Location Details';
export const editHeader = 'Edit Location Details';

export const ERROR_MESSAGES = {
    ID_REQUIRED: 'Field is required.',
    LOCATION_REQUIRED: 'Field is required.',
};
